"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_VIDEO_BYTES = void 0;
exports.validateVideoFile = validateVideoFile;
exports.isVideoFileUrl = isVideoFileUrl;
exports.getGalleryYoutubeUrl = getGalleryYoutubeUrl;
exports.MAX_VIDEO_BYTES = 50 * 1024 * 1024;
function validateVideoFile(file) {
    if (file.size <= 0 || file.size > exports.MAX_VIDEO_BYTES)
        return '동영상은 0MB 초과, 50MB 이하만 업로드할 수 있습니다.';
    const extension = file.name.split('.').pop()?.toLowerCase();
    if (!((extension === 'mp4' && file.type === 'video/mp4') ||
        (extension === 'webm' && file.type === 'video/webm')))
        return 'MP4 또는 WebM 동영상 파일만 업로드할 수 있습니다.';
    return null;
}
function isVideoFileUrl(url) {
    try {
        const parsed = new URL(url);
        return (['https:', 'http:'].includes(parsed.protocol) &&
            /\.(mp4|webm)$/i.test(parsed.pathname));
    }
    catch {
        return false;
    }
}
function getGalleryYoutubeUrl(url) {
    try {
        const parsed = new URL(url);
        if (!['https:', 'http:'].includes(parsed.protocol))
            return '';
        let id = null;
        if (parsed.hostname === 'youtu.be')
            id = parsed.pathname.slice(1);
        else if ([
            'youtube.com',
            'www.youtube.com',
            'm.youtube.com',
            'www.youtube-nocookie.com',
        ].includes(parsed.hostname)) {
            id =
                parsed.pathname === '/watch'
                    ? parsed.searchParams.get('v')
                    : parsed.pathname.match(/^\/(?:embed|shorts|live)\/([^/]+)$/)?.[1] ??
                        null;
        }
        return id && /^[\w-]{11}$/.test(id)
            ? `https://www.youtube.com/embed/${id}`
            : '';
    }
    catch {
        return '';
    }
}
